import type { IText, Textbox, TextStyle, TextStyleDeclaration } from 'fabric';

// Per-character styles. Fabric owns the highlighted range, so it maps the range onto
// char styles and the caller stores the result.

export type TextObject = IText | Textbox;

export const selectionRange = (textObject: TextObject): [number, number] | null => {
  if (!textObject.isEditing) return null;
  const start = textObject.selectionStart ?? 0;
  const end = textObject.selectionEnd ?? 0;
  return start === end ? null : [start, end];
};

export const readSelectionStyle = (textObject: TextObject): TextStyleDeclaration | null => {
  const range = selectionRange(textObject);
  if (!range) return null;
  return textObject.getSelectionStyles(range[0], range[1], true)[0] ?? null;
};

/** Paints the highlighted range and returns the resulting styles. */
export const writeSelectionStyle = (
  textObject: TextObject,
  field: keyof TextStyleDeclaration,
  value: string | number | boolean
): TextStyle => {
  textObject.setSelectionStyles({ [field]: value });
  textObject.dirty = true;
  return structuredClone(textObject.styles);
};
